<template>
    <video
        :src="require( '@/assets/images/stage_backgrounds/' + video )"
        :poster="require( '@/assets/images/stage_backgrounds/' + poster )"
        autoplay loop muted
    />
</template>

<script>
export default {
    name:'VideoWrap',
    props: ['videoSrc'],
    computed: {
        poster() { return this.videoSrc.replace(/\.\w{3}\b/, '.jpg') },
        video() { return this.videoSrc.replace(/\.\w{3}\b/, '.mp4') },
    },
}
</script>
